import { useMemo } from "react";
import { formatCountdownTime } from "../../utils/loyalty/formatCountdownTime";
import useCountdown from "../../hooks/useCountdown";
import { CUSTOMER_ACCESS_PURCHASE, CUSTOMER_ACCESS_VIEW } from "../../constants";
import { formatDateForLoyalty } from "../../../common/releaseDateBanner/formatDateForLoyalty";

export const useTranslatedText = (getTranslation, customerAccess, endDate) => {
  const { remainingSeconds, showCountdown } = useCountdown(endDate);

  return useMemo(() => {

    if (![CUSTOMER_ACCESS_VIEW, CUSTOMER_ACCESS_PURCHASE].includes(customerAccess)) {
      return null;
    }

    if (showCountdown) {
      const translationString = customerAccess === CUSTOMER_ACCESS_PURCHASE
        ? "early_access_taping_early_access_countdown"
        : "early_access_taping_coming_soon_countdown";
      return getTranslation(translationString, { time: formatCountdownTime(remainingSeconds) });
    }

    const translationString = customerAccess === CUSTOMER_ACCESS_PURCHASE
      ? "early_access_taping_early_access_end_date"
      : "early_access_taping_coming_soon_end_date";
    return getTranslation(translationString, { date: formatDateForLoyalty(endDate) });
  }, [customerAccess, showCountdown, remainingSeconds, endDate, getTranslation]);
};
